import { Table, styled } from "@mui/material";

const CustomTable = styled(Table)(({ theme }) => ({
  //   " & .MuiTableHead-root .MuiTableCell-root MuiTypography-root": {
  //     backgroundColor: "red",
  //   },
  "& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root .MuiTypography-root": {
    fontWeight: "600",
    color: theme.palette.primary.main,
  },
}));

export default CustomTable;
